import { h } from "omi";

export function CountryPHIcon() {
  return (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#a)">
        <path
          d="M10 20c5.5228 0 10-4.4772 10-10 0-5.5229-4.4772-10-10-10C4.4771 0 0 4.4771 0 10c0 5.5228 4.4771 10 10 10Z"
          fill="#F0F0F0"
        />
        <path
          d="M10.0003 0v10l-7.0711 7.0711C4.7389 18.8807 7.2389 20 10.0003 20c5.5228 0 10-4.4772 10-10s-10-10-10-10Z"
          fill="#D80027"
        />
        <path
          d="M10.0003 0C7.2389 0 4.7389 1.1193 2.9292 2.929L10.0003 10h10c0-5.5228-4.4772-10-10-10Z"
          fill="#0052B4"
        />
        <path
          d="m6.8476 9.9997-1.2212-.5744.6503-1.1828-1.3262.2537-.168-1.3397-.9238.9853-.9237-.9853-.168 1.3397-1.3262-.2537.6504 1.1828-1.2213.5744 1.2213.5745-.6504 1.1828 1.3263-.2537.1679 1.3397.9237-.9853.9238.9853.168-1.3397 1.3261.2537-.6503-1.1828 1.2213-.5745ZM2.6672 3.9126l.4064.568.6658-.2108-.4147.562.4064.5681-.6628-.2207-.4147.562.0052-.6985-.6627-.2208.666-.2109.005-.6984ZM2.6672 14.2578l.4064.5681.6658-.2109-.4147.562.4064.5681-.6628-.2207-.4147.562.0052-.6985-.6627-.2208.666-.2108.005-.6985ZM8.4636 9.086l-.4064.568-.6658-.211.4147.5621-.4064.5681.6627-.2207.4148.562-.0052-.6984.6627-.2208-.666-.211-.0051-.6984Z"
          fill="#FFDA44"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
